/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Skeleton } from 'primereact/skeleton';
import { classNames } from 'primereact/utils';
import { useSelector } from 'react-redux';
import { PDTServe } from '../services/api/PDTServ';
import './ListPredefinedTemplate.css'

const ListPredefinedTemplate = ({ setSelectedTemplate  }) => {
    const [lpList, setLpList] = useState([1, 2, 3, 4, 5, 6]);
    const [activeIndex, setActiveIntex] = useState(null);
    const [loader, setLoader] = useState(true);
    const lpDetails = useSelector((state) => state.createLp.data)
    



    const getPdts = async () => {
        try {
            // console.log(netLineTemplate);
            let templates = await PDTServe.index();
            setLpList(templates)
            if(lpDetails){
                for (const i in templates) {
                    if(templates[i]._id===lpDetails.pdtId){
                        templates[i].templateNo = i;
                        handleChange(i);
                        console.log(i)
                        break;
                    }
                }
            }
            
        } catch (error) {
            console.log(error)
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {
        setTimeout(async () => {
            await getPdts()
        }, 2000)
    }, []);

    const handleChange= (index) => {
        setActiveIntex(index);
        setSelectedTemplate(lpList[index] , index);
        console.log(lpList[index])
        }

   


    const listItem = (lp, i) => {
        return (
            <>
                {
                    loader === true ?
                        (
                            <div className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', { 'border-top-1 surface-border': i !== 0 })}>
                                <Skeleton className="w-9 sm:w-16rem xl:w-10rem shadow-2 h-6rem block xl:block mx-auto border-round" />
                                <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                                    <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                                        <Skeleton className="w-8rem border-round h-2rem" />
                                        <Skeleton className="w-6rem border-round h-1rem" />
                                        <div className="flex align-items-center gap-3">
                                            <Skeleton className="w-6rem border-round h-1rem" />
                                            <Skeleton className="w-3rem border-round h-1rem" />
                                        </div>
                                    </div>
                                    <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                                        <Skeleton className="w-4rem border-round h-2rem" />
                                        <Skeleton shape="circle" className="w-3rem h-3rem" />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className={classNames(`flex mb-2 flex-column xl:flex-row xl:align-items-start p-4 gap-4 `, { 'border-top-1 surface-border': i !== 0 })}>
                                <img className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round" src={lp.skeleton} alt={lp.name} />
                                <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                                    <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                                        <div className="text-2xl font-bold text-900">{lp.name}</div>
                                        {/* <Rating value={lp.rating} readOnly cancel={false}></Rating> */}
                                        <div className="flex align-items-center gap-3">
                                            {/* <span className="flex align-items-center gap-2">
                                                <i className="pi pi-tag"></i>
                                                <span className="font-semibold">{lp.category}</span>
                                            </span> */}
                                            {/* <Tag value={lp.inventoryStatus} severity={getSeverity(lp)}></Tag> */}
                                        </div>
                                    </div>
                                    <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                                        <span className="text-2xl font-semibold"> 
                                        </span>
                                        {/* <Button icon="pi pi-shopping-cart" className="p-button-rounded" disabled={lp.inventoryStatus === 'OUTOFSTOCK'}></Button> */}
                                    </div>
                                </div>
                            </div>
                        )

                }
            </>);
    };

    return (
        <div className="grid grid-nogutter">{lpList.map((lp, index) => <div className={`col-8 col-offset-2  pdtItem ${activeIndex === index ? "pdtItemActive" : ""}`} onClick={(e) => handleChange(index)} key={index}>{listItem(lp, index)}</div>)}</div>
    )
}

export default ListPredefinedTemplate